var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYardFk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.79488 0 0.230774 2.4948 0.230774 5.61331C0.230774 9.48025 2.41026 12.9106 5.67949 14.9064C5.8718 15.0312 6.12821 15.0312 6.38462 14.9064C9.58975 12.8482 11.7692 9.48025 11.7692 5.61331C11.7692 2.4948 9.20513 0 6 0ZM6 8.10811C4.58975 8.10811 3.4359 6.98545 3.4359 5.61331C3.4359 4.24116 4.58975 3.1185 6 3.1185C7.41026 3.1185 8.56411 4.24116 8.56411 5.61331C8.56411 6.98545 7.41026 8.10811 6 8.10811Z",
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYardFk);
export default __webpack_public_path__ + "static/media/yardFK.5912d8d5392f192af3f856daeba722e6.svg";
export { ForwardRef as ReactComponent };